import React, { useEffect, useRef } from 'react';
import { RAZORPAY_KEY } from '../redux/config';

const RazorpayPayment = ({ storeData, orderDetails, onPaymentSuccess }) => {
    const paymentPageOpened = useRef(false)
    useEffect(() => {
        console.log("useeffect");

        if (orderDetails && !paymentPageOpened.current) {
            loadRazorpay();
            paymentPageOpened.current = true
        }
    }, [orderDetails, storeData]);

    const loadRazorpay = () => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            const options = {
                key: RAZORPAY_KEY,  // Replace with your Razorpay Key ID
                amount: orderDetails.amount,
                currency: orderDetails.currency,
                name: "Invetix POS",
                description: "Subscription Payment",
                order_id: orderDetails.id,
                handler: function (response) {
                    onPaymentSuccess({
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_signature: response.razorpay_signature
                    });
                },
                prefill: {
                    name: storeData?.name,
                    email: storeData?.email,
                    contact: `${storeData?.mobile}`
                },
                theme: {
                    color: "#3399cc"
                }
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();
        };
    };

    return null;
};

export default RazorpayPayment;
